import React, { useEffect, useState } from 'react'
import AInvbasicDetail from './AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi, getReserveInvoiceApi } from '../apiService'
import { globalGetService, globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { PageLoader, titanAviationIntance } from '../../../shared_elements'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { trackActivity } from '../../../utils/mixpanel'
import WarningModal from './WarningModal'
import { getAdditionalTax, getTotalTax } from '..'
import { getInvoiceDialogWidthProps } from './AInvItems'

const AddReserveInv = ({ toggleInvModel, modeType, item, resrveInvoice, setResrveInvoice }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const { enqueueSnackbar } = useSnackbar();
	const [attachments, setAttachments] = useState([]);
	const [tableErrors, setTableErrors] = useState({});
	const [error, setError] = useState({});
	const [warning, setWarning] = useState({modal:false});
	const [pendingPayload, setPendingPayload] = useState(null);
	const [isLoading, setLoading] = useState(false)
	const [activeTaxList, setActiveTaxList] = useState([]);

	const totalLGGropingAmount = resrveInvoice.invoice_items?.filter((item) =>item?.asset?.asset_type === 4)?.reduce( (sum, item) => sum + (Number(item?.sub_total) || 0) + (Number(item?.tax_amount) || 0), 0 ); 
	const lgGroupedAllocation = item?.is_lg_grouped ? (resrveInvoice?.invoice_items?.find((item) => item.asset?.asset_type === 4)?.grouped_lgs || [])?.map((row, index, arr) => {
		const percent = row.percentage / 100;
		let amount;
		if (index === arr.length - 1) {
			const usedAmount = arr?.slice(0, index)?.reduce((sum, item) => sum + Number(((totalLGGropingAmount * item.percentage) / 100)?.toFixed(2)), 0);
			amount = (totalLGGropingAmount - usedAmount)?.toFixed(2);
		} else {
			amount = ((totalLGGropingAmount * row.percentage) / 100)?.toFixed(2);
		}
		return {
			asset_id: row.asset_id, asset_type: 4, asset_name: row.asset_name, percentage: row.percentage, amount: Number(String(amount).replace(/,/g, "")),
			display_amount: Number(String(amount).replace(/,/g, "")).toLocaleString(
				"en-US",
				{
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				  }
				), note: `${resrveInvoice?.currency?.symbol || ""}${totalLGGropingAmount.toLocaleString()} × ${percent.toFixed(4)}`, };
		}):[]


	const submitInvoice = (payload) => {
		setLoading(true);
		globalPostService(addInvoiceApi(), { ...payload, lease_slug: item?.lease_slug })
			.then(response => {
				if (checkApiStatus(response)) {
					if (attachments?.length) {
						dispatch(setUploadFiles({ modal: true, slug: response?.data?.data?.slug }));
					}
					toggleInvModel();
					trackActivity('Item Added', { page_title: `Add Reserve Invoice`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
					setLoading(false);
					navigate(`/invoices/view/${response?.data?.data?.slug}`, { state: { from: 'viewFromLease' } })
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
					setPendingPayload({})
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
					setLoading(false);
					trackActivity('Item Added', { page_title: `Add Reserve Invoice`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
				}
			})
	}

	const onAddEditInvoice = () => {
		let validationInputs = {
			invoice_number: resrveInvoice?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
			date: resrveInvoice?.date ? '' : 'Please select Invoice Date',
			due_date: resrveInvoice?.due_date ? '' : 'Please select Invoice Due Date',
			currency: resrveInvoice?.currency ? '' : 'Please select Currency',
			bank: resrveInvoice?.bank?.id ? '' : 'Please select Bank',
		}

		const invoiceDate = moment(resrveInvoice?.date);
		const dueDate = moment(resrveInvoice?.due_date);
		const maxAllowedDate = moment(leaseBasicDetails?.end_date).add(3, 'months');
		if (resrveInvoice?.date && resrveInvoice?.due_date) {
			if (dueDate.isBefore(invoiceDate)) {
				validationInputs.due_date = "Due Date cannot be before Invoice Date";
			}
			if (invoiceDate.isAfter(dueDate)) {
				validationInputs.date = "Invoice Date cannot be after Due Date";
			}
			if (invoiceDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.date = `Invoice Date cannot be before Lease Start Date`;
			}
			if (invoiceDate.isAfter(maxAllowedDate)) {
				validationInputs.date = "Invoice Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isAfter(maxAllowedDate)) {
				validationInputs.due_date = "Due Date must be within 3 months after the Lease End Date.";
			}
			if (dueDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Lease Start Date";
			}
			if (invoiceDate.isBefore(resrveInvoice?.start_date)) {
				validationInputs.date = "Invoice Date cannot be before Period Start Date";
			}
			if (dueDate.isBefore(resrveInvoice?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Period Start Date";
			}
			if (resrveInvoice?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (resrveInvoice?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
		}
		setError({ ...validationInputs });

		let newErrors = {};
		resrveInvoice.invoice_items.forEach((row, index) => {
			const errors = {};

			if (!titanAviationIntance && !row.description?.trim()) {
				errors.description = "Please enter Description";
			}

			if (Object.keys(errors).length > 0) {
				newErrors[index] = errors;
			}
		});

		setTableErrors(newErrors)
		if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
			trackActivity(`Item Added`, { page_title: 'Add Reserve Invoice', error_msg: validationInputs, })
			return;
		}

		let payload = Object.assign({}, resrveInvoice)


		payload = {
			invoice_number: resrveInvoice?.invoice_number || null,
			start_date: resrveInvoice?.start_date || null,
			end_date: resrveInvoice?.end_date || null,
			date: resrveInvoice?.date || null,
			due_date: resrveInvoice?.due_date || null,
			currency: resrveInvoice?.currency?.code || null,
			bank: resrveInvoice?.bank || null,
			from: resrveInvoice?.from || null,
			to: resrveInvoice?.to || null,
			remarks: resrveInvoice?.remarks || null,
			invoice_type: { label: 'Reserve', value: 1 },
			asset : resrveInvoice?.asset ? resrveInvoice?.asset : null,
			footer_note : resrveInvoice?.bank?.footer_note || null,
			trustee_id : resrveInvoice?.trustee_id ? resrveInvoice?.trustee_id : null,
			invoice_items: Array.isArray(resrveInvoice?.invoice_items)
                ? resrveInvoice.invoice_items.map((items) => {
                      const subTotal = Number(items?.sub_total) || 0;
                      const taxRate = Number(items?.tax_rate) || 0;
                      const taxAmount = subTotal * (taxRate / 100);
                      const subAmountTotal = subTotal + taxAmount;
					  const isGroupedLG = items?.asset?.asset_type === 4 && item?.is_lg_grouped === true;
                      return {
				invoice_item_name: items?.invoice_item_name ? items?.invoice_item_name : null,
				description: items?.description ? items?.description : null,
				unit_description: items?.unit_description ? items?.unit_description : null,
				no_of_units: items?.no_of_units ? items?.no_of_units : 0,
				rate_per_unit: items?.rate_per_unit ? items?.rate_per_unit : 0,
				sub_total: items?.sub_total ? items?.sub_total : 0,
				tax_rate: normalizeTaxRate(items?.tax_rate),
				tax_amount: items?.tax_amount ? Number(items?.tax_amount) : 0,
				sub_amount_total: subAmountTotal.toFixed(4),
				reserve: items?.reserve ? items?.reserve : null,
				asset: items?.asset ? items?.asset : null,
				sub_reference_id: items?.reserve ? items?.reserve : null,
				...(isGroupedLG && {
					is_grouped_lgs: true,
					lg_allocations: Array.isArray(lgGroupedAllocation) && lgGroupedAllocation?.length>0
					  ? lgGroupedAllocation?.map((row) => ({
						  asset_id: row?.asset_id,
						  asset_type: 4,
						  percentage: Number(row?.percentage) || 0,
						  amount: Number(String(row?.amount).replace(/,/g, "")) || 0,
						}))
					  : [],
				  }),
			};
                  })
                : [],
        };
		let updatedInvoiceItems = getAdditionalTax(payload?.invoice_items, activeTaxList)
		let tax_details = getTotalTax(payload?.invoice_items, activeTaxList)
		payload = {
			...payload,
			tax_details: tax_details,
			invoice_items: updatedInvoiceItems,
		}

		if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; }) && Object.keys(newErrors).length === 0) {
			if (resrveInvoice?.has_invoice_warning) {
				setPendingPayload({...payload,force_create :true});
				setWarning({ modal: true });
			} else {
				submitInvoice(payload);
			}
		} else {
			trackActivity(`Item Added`, { page_title: 'Add Reserve Invoice', error_msg: validationInputs, })
		}
	};

	const handleFileChange = (files) => {
		setAttachments(files);
		dispatch(setFileUploadDetails({ attachments: files }))
	};

	const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
		if (invoiceItem) {
			if (keyParam === "sub_total" || keyParam === "tax_rate") {
				setResrveInvoice(prev => {
					const currentItem = prev.invoice_items[itemIndex];
					const subTotal = keyParam === "sub_total"
						? parseFloat(value) || 0
						: parseFloat(currentItem.sub_total) || 0;
					const taxRate = keyParam === "tax_rate"
						? parseFloat(value) || 0
						: parseFloat(currentItem.tax_rate) || 0;
					const taxAmount = subTotal * (taxRate / 100);
					const subAmountTotal = subTotal + taxAmount;
					return {
						...prev,
						invoice_items: prev.invoice_items.map((item, index) =>
							index !== itemIndex
								? item
								: {
									...item,
									[keyParam]: value,
									tax_amount: taxAmount.toFixed(4),
									sub_amount_total: subAmountTotal.toFixed(4),
								}
						),
					};
				});
			} else {
				setResrveInvoice(prev => ({
					...prev,
					invoice_items: prev.invoice_items.map((item, index) =>
						index !== itemIndex ? item : { ...item, [keyParam]: value }
					),
				}));
			}
		} else {
			setResrveInvoice(prev => ({ ...prev, [keyParam]: value }));
		}
	};

	const onRestErrorKey = (keyParam) => {
		setError({ ...error, [keyParam]: '' })
	}

	const resetTableError = (rowIndex, fieldName) => {
		setTableErrors((prevErrors) => {
			const rowErrors = { ...prevErrors[rowIndex] };
			delete rowErrors[fieldName];

			const updatedErrors = { ...prevErrors };
			if (Object.keys(rowErrors).length === 0) {
				delete updatedErrors[rowIndex];
			} else {
				updatedErrors[rowIndex] = rowErrors;
			}

			return updatedErrors;
		});
	};
	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Add Reserve Invoice`, page_type: page_type, })
	}
	return (
		<>
			<Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' {...getInvoiceDialogWidthProps({ invoice: { ...resrveInvoice, invoice_type: { label: 'Reserve', value: 1 } }, type: 'reserveInvoice', activeTaxList }, 'xl')} open={true} style={{ overflowY: "unset" }} >
				<DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
					Add Reserve Invoice
				</DialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<AInvbasicDetail addEditInvoice={resrveInvoice} type={'reserveInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={{...resrveInvoice, invoice_type: { label: 'Reserve', value: 1 }}} error={error} handleFileChange={handleFileChange} tableErrors={tableErrors} resetTableError={resetTableError} leaseSlug={item?.lease_slug} onActiveTaxLoad={setActiveTaxList} isGroupedLG={item?.is_lg_grouped} lgGroupedAllocation={lgGroupedAllocation}/>
					</Grid>
				</DialogContent>
				<DialogActions sx={{ marginRight: "15px" }}>
					<Button className='cancel-btn' variant='outlined' size='small' onClick={() => { toggleInvModel(); handleItemClicked('Cancel Button') }} > Cancel </Button>
					<Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice(); }}>
						{isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
					</Button>
				</DialogActions>
			</Dialog>
			{warning.modal && <WarningModal invoice={resrveInvoice} warning={warning} onToggleModal={() => setWarning({ modal: false })} onProceed={() => submitInvoice(pendingPayload)} isLoading={isLoading} />}
			{isLoading ? <PageLoader /> : null}
		</>
	)
}

export default AddReserveInv